export default "__VITE_ASSET__62ef6aeb__"